import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';

export default function Primer3Menu(): JSX.Element {
  return (
    <ul className="nav navbar-nav form-inline primer3-menu">
      <li>
        <button
          type="button"
          disabled={true}
          className="button button--primary button--mini js-save"
          {...getTestProps({component: 'Primer3Menu', element: 'savePrimersButton'})}
        >
          Save Selected Primers
        </button>
        <button
          type="button"
          disabled={true}
          className="button button--tertiaryGray u-small-spacing-left button--mini js-export-as-csv"
        >
          Export as CSV
        </button>
      </li>
      <div className="buttonGroup binding-site-sort-group pull-right">
        <Button
          isDropdown={true}
          buttonStyle={ButtonStyle.TERTIARY_GRAY}
          size={ButtonSize.MINI}
          text={
            <span>
              <span className="faded">Sort by</span> <span className="primer-sort-by">Penalty</span>
            </span>
          }
        />
        <ul className="dropdown-menu">
          <li>
            <a href="#" className="sort-by sort-by-penalty">
              Penalty
            </a>
          </li>
          <li>
            <a href="#" className="sort-by sort-by-location">
              Location
            </a>
          </li>
          <li>
            <a href="#" className="sort-by sort-by-productBP">
              Product BP
            </a>
          </li>
        </ul>
      </div>
      <a className="tm-params pull-right">
        T<sub>m</sub> params
      </a>
    </ul>
  );
}
